<template>
	<header class="Header">
		<div class="burger-menu">
			<a href="#" class="sidebar-menu-open btn btn-primary" @click.prevent="openMenu">
				<img src="@/assets/burger-menu.png" alt="Menu" />
			</a>
			<div class="sidebar-menu-overlay" :class="{ 'show-menu': isMenuOpen }">
				<div class="sidebar-menu">
					<div class="sidebar-top">
						<img class="logo" src="@/assets/Logo/logo3.png" alt="Logo" />
						<a href="#" class="btn btn-primary sidebar-menu-close" @click.prevent="closeMenu">
							<img src="@/assets/cross.png" alt="Close" />
						</a>
					</div>
					<ul id="menu">
						<li v-for="item in menuItems" :key="item.text">
							<router-link
								v-if="item.genre"
								:to="{ path: '/all-genres', query: { genre: item.genre } }"
								:class="{ selected: isActiveGenre(item.genre) }"
								@click="closeMenu"
							>
								{{ item.text }}
							</router-link>

							<router-link
								v-else
								:to="item.link"
								:class="{ selected: isActiveRoute(item.link) }"
								@click="closeMenu"
							>
								{{ item.text }}
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="Header_logo">
			<router-link to="/">
				<img class="logo" src="@/assets/Logo/logo3.png" alt="Logo" />
			</router-link>
		</div>

		<div class="header_btn">
			<div class="lang-container">
				<a class="lang">
					<button class="lang-btn" @click="toggleDropdown">
						{{ selectedLanguage }}
						<img class="arrow" src="@/assets/arrow.png" />
					</button>
				</a>
			</div>

			<!-- Dropdown Menu -->
			<ul
				class="lang-dropdown"
				v-if="isDropdownVisible && locals && locals.hostConfig && locals.hostConfig.locales"
			>
				<li
					v-for="locale in locals.hostConfig.locales"
					:key="locale"
					@click="selectLanguage(locals.languages[locale], locale)"
				>
					{{ locals.languages[locale] }}
				</li>
			</ul>

			<div class="user_profile">
				<router-link :to="locals.loggedIn ? '/profile' : '/login'">
					<img src="@/assets/profile-icon.png" alt="Profile" />
				</router-link>
			</div>
		</div>
	</header>
</template>

<script>
export default {
	props: {
		locals: Object,
	},
	data() {
		return {
			isMenuOpen: false,
			isDropdownVisible: false,
			menuItems: [],
		};
	},

	created() {
		this.loadMenuItems();
		// this.getSavedLanguage();
	},

	computed: {
		selectedLanguage: {
			get() {
				const cookieLang = this.getCookie('lang');
				const code = cookieLang || this.locals?.hostConfig?.default_locale;
				return this.locals?.languages?.[code] || 'Language';
			},
		},
		activeGenre() {
			return this.$route.path === '/all-genres' ? this.$route.query.genre : null;
		},
	},

	mounted() {
		this.scrollToSelectedGenre();
		document.addEventListener('click', this.handleClickOutside);
	},

	beforeUnmount() {
		document.removeEventListener('click', this.handleClickOutside);
	},

	watch: {
		'$route.query.genre': function () {
			this.scrollToSelectedGenre();
		},
	},

	methods: {
		getCookie(name) {
			const value = `; ${document.cookie}`;
			const parts = value.split(`; ${name}=`);
			if (parts.length === 2) {
				return parts.pop().split(';').shift();
			}
			return null;
		},
		openMenu() {
			this.isMenuOpen = true;
		},

		closeMenu() {
			this.isMenuOpen = false;
		},

		toggleDropdown(event) {
			event.stopPropagation();
			this.isDropdownVisible = !this.isDropdownVisible;
		},

		selectLanguage(language, code) {
			this.selectedLanguage = language;
			this.isDropdownVisible = false;
			document.cookie = `lang=${code}; path=/;`;
			return window.location.reload();
			// this.$router.push({ query: { lang: code } });
		},

		handleClickOutside(event) {
			if (!this.$el.contains(event.target)) {
				this.isDropdownVisible = false;
			}
		},

		getSavedLanguage() {
			const savedLang = JSON.parse(localStorage.getItem('selectedLanguage'));
			if (savedLang) {
				this.selectedLanguage = savedLang.language;
				this.$router.push({ query: { lang: savedLang.code } });
			}
		},

		async loadMenuItems() {
			try {
				const response = await fetch('/games.json');
				if (!response.ok) throw new Error('Failed to load games.json');
				const gamesData = await response.json();

				if (!Array.isArray(gamesData)) {
					console.error('gamesData is not an array');
					return;
				}

				const genres = new Set();

				gamesData.forEach((game) => {
					if (Array.isArray(game.genres)) {
						game.genres.forEach((genre) => genres.add(genre));
					}
				});

				this.menuItems = [
					{ text: 'Home', link: '/' },
					{ text: 'Login', link: '/login' },
					{ text: 'Your Profile', link: '/profile' },
					...Array.from(genres).map((genre) => ({ text: genre, genre })),
				];
			} catch (error) {
				console.error('Error loading games.json:', error);
			}
		},

		scrollToSelectedGenre() {
			const genre = this.$route.query.genre;
			if (genre) {
				this.$nextTick(() => {
					const element = document.getElementById(genre);
					if (element) {
						element.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}
				});
			}
		},

		isActiveRoute(route) {
			return this.$route.path === route;
		},

		isActiveGenre(genre) {
			return this.activeGenre === genre;
		},
	},
};
</script>

<style>
/* Show dropdown */
.lang-dropdown[v-show='true'] {
	display: block;
}
</style>
